import ThemeManager from "project-config/services/theme-manager";
ThemeManager.init();
const newTheme = ThemeManager.newTheme;

export enum ActionName {
  "start" = 1,
  "stop" = 2,
  "abandon" = 3,
  "submit" = 4,
  "delete" = 5,
  "download" = 6,
  "render" = 7,
  "clone" = 8,
  "hardware" = 9,
  "deduct" = 10,
  "software" = 11,
  "customFrame" = 12,
  "crossPlatformClone" = 13,
  "crossPlatformTransferAssets" = 14,
  "downloadSequence" = 15,
  "share" = 16,
}

// RENDERING_TASK_WAITING((byte) 0, "WAITING", "等待中//首先大任务的状态是start，没有running的任务即为等待", "render_task_status_0"),
// RENDERING_TASK_RENDERING((byte) 5, "RENDERING", "渲染中//首先大任务的状态是start，只要有running的任务即为渲染中", "render_task_status_5"),
// RENDERING_PRE_TASK_RENDERING((byte) 8, "PRE_RENDERING", "针对预处理任务，开始的预处理，状态为预处理中", "render_task_status_8"),
// RENDERING_TASK_STOP((byte) 10, "STOP", "停止", "render_task_status_10"),
// RENDERING_TASK_ARREARAGE_STOP((byte) 20, "ARREARAGE_STOP", "停止(欠费)", "render_task_status_20"),
// RENDERING_TASK_TIME_OUT((byte) 23,"TIME_OUT_STOP","超时停止","render_task_status_23"),
// RENDERING_TASK_FINISHED((byte) 25, "FINISHED", "已完成", "render_task_status_25"),
// RENDERING_TASK_FINISHED_HAS_FAILED((byte) 30, "FINISHED_HAS_FAILED", "已完成但有失败帧", "render_task_status_30"),
// RENDERING_TASK_ABANDON((byte) 35, "ABANDON", "放弃", "render_task_status_35"),
// RENDERING_TASK_FINISHED_TEST((byte) 40, "FINISHED_TEST", "测试完成", "render_task_status_40"),
// RENDERING_TASK_FAILED((byte) 45, "FAILED", "失败", "render_task_status_45"),
// RENDERING_TASK_ANALYSE((byte) 50, "ANALYSE", "分析中", "render_task_status_50"),
// RENDERING_TASK_STATUS_UPDATING((byte) 100, "UPDATING", "状态更新中", "render_task_status_100"),
// RENDERING_TASK_SUBMITTING((byte) 60, "RENDERING_TASK_SUBMITTING", "任务提交中", "rendering_task_submitting_60"),
// RENDERING_TASK_SUBMIT_FAIL((byte) 65, "RENDERING_TASK_SUBMIT_FAIL", "任务解析失败", "rendering_task_submit_fail_65");

export enum TaskStatus {
  /** 等待中 */
  waiting = 0,
  /** 渲染中 */
  rendering = 5,
  /** 预处理中 */
  preRendering = 8,
  /** 停止 */
  stop = 10,
  /** 欠费停止 */
  arrearageStop = 20,
  /** 超时停止 */
  timeOutStop = 23,
  /** 已完成 */
  finished = 25,
  finishedHasStopped = 70,
  /** 已完成但有失败帧 */
  finishedHasFailed = 30,
  /** 放弃 */
  abandon = 35,
  /** 等待全速渲染 */
  finishedTest = 40,
  /** 失败 */
  failed = 45,
  /** 分析中 */
  analyse = 50,
  /** 更新中 */
  updating = 100,
  /** 提交中 */
  renderingTaskSubmitting = 60,
  /** 提交失败 */
  renderTaskSumbitFail = 65,
}

export enum CustomStatus {
  waitingAndNotMunuTaskId = 10000,
}

export enum StopType {
  USER = 1,
  AMIN = 2,
  ARREAR = 3,
}

export enum StopStatusEnum {
  UNKNOW = 0,
  USER_STOP,
  ADMIN_STOP,
  OUTSTANDING_FEES_STOP,
}

export const PendingTaskStatus = [
  TaskStatus.waiting,
  TaskStatus.rendering,
  TaskStatus.preRendering,
  TaskStatus.updating,
  TaskStatus.renderingTaskSubmitting,
];

export const NoFullSpeedStatus = [
  TaskStatus.renderTaskSumbitFail,
  TaskStatus.preRendering,
  TaskStatus.finished,
  TaskStatus.finishedHasFailed,
  TaskStatus.renderingTaskSubmitting,
  TaskStatus.failed,
  TaskStatus.updating,
  TaskStatus.timeOutStop,
  TaskStatus.waiting,
  TaskStatus.stop,
  TaskStatus.arrearageStop,
];

export const AllActionName = [
  ActionName.start,
  ActionName.stop,
  ActionName.abandon,
  ActionName.delete,
  ActionName.submit,
  ActionName.download,
  ActionName.downloadSequence,
  ActionName.render,
  ActionName.clone,
  ActionName.hardware,
  ActionName.deduct,
  ActionName.crossPlatformClone,
  ActionName.crossPlatformTransferAssets,
  ActionName.share,
];

export const ActionNameMap = new Map<ActionName, keyof typeof ActionName>([
  [ActionName.start, "start"],
  [ActionName.stop, "stop"],
  [ActionName.abandon, "abandon"],
  [ActionName.delete, "delete"],
  [ActionName.submit, "submit"],
  [ActionName.download, "download"],
  [ActionName.downloadSequence, "downloadSequence"],
  [ActionName.render, "render"],
  [ActionName.clone, "clone"],
  [ActionName.hardware, "hardware"],
  [ActionName.deduct, "deduct"],
  [ActionName.crossPlatformClone, "crossPlatformClone"],
  [ActionName.crossPlatformTransferAssets, "crossPlatformTransferAssets"],
  [ActionName.share, "share"],
]);

export const DisableAction = [
  ActionName.delete,
  ActionName.download,
  ActionName.downloadSequence,
  ActionName.deduct,
  // todelete
  ActionName.hardware,
];
export const DeletedAction = [ActionName.download, ActionName.downloadSequence];
export const VRSoftAction = [
  ActionName.start,
  ActionName.stop,
  ActionName.abandon,
  ActionName.delete,
  ActionName.submit,
  ActionName.download,
  ActionName.downloadSequence,
  ActionName.render,
  ActionName.hardware,
  ActionName.deduct,
  ActionName.clone,
];
export const ArnoldSoftAction = [
  ActionName.start,
  ActionName.stop,
  ActionName.abandon,
  ActionName.delete,
  ActionName.submit,
  ActionName.download,
  ActionName.downloadSequence,
  ActionName.render,
  ActionName.hardware,
  ActionName.deduct,
];

export const StatusActionMap = new Map<number, ActionName[]>([
  [
    TaskStatus.waiting,
    [
      ActionName.stop,
      ActionName.abandon,
      ActionName.delete,
      ActionName.download,
      ActionName.downloadSequence,
      ActionName.render,
      ActionName.clone,
      ActionName.hardware,
      ActionName.deduct,
      ActionName.submit,
      ActionName.crossPlatformClone,
      ActionName.crossPlatformTransferAssets,
      ActionName.share,
    ],
  ],
  [
    TaskStatus.rendering,
    [
      ActionName.stop,
      ActionName.abandon,
      ActionName.delete,
      ActionName.download,
      ActionName.downloadSequence,
      ActionName.render,
      ActionName.clone,
      ActionName.hardware,
      ActionName.deduct,
      ActionName.submit,
      ActionName.crossPlatformClone,
      ActionName.crossPlatformTransferAssets,
      ActionName.share,
    ],
  ],
  [
    TaskStatus.failed,
    [
      ActionName.abandon,
      ActionName.delete,
      ActionName.submit,
      ActionName.download,
      ActionName.downloadSequence,
      ActionName.clone,
      ActionName.hardware,
      ActionName.deduct,
      ActionName.crossPlatformClone,
      ActionName.crossPlatformTransferAssets,
      ActionName.share,
    ],
  ],
  [
    TaskStatus.stop,
    [
      ActionName.start,
      ActionName.abandon,
      ActionName.delete,
      ActionName.submit,
      ActionName.download,
      ActionName.downloadSequence,
      ActionName.clone,
      ActionName.hardware,
      ActionName.deduct,
      ActionName.render,
      ActionName.crossPlatformClone,
      ActionName.crossPlatformTransferAssets,
      ActionName.share,
    ],
  ],
  [
    TaskStatus.arrearageStop,
    [
      ActionName.start,
      ActionName.abandon,
      ActionName.delete,
      ActionName.submit,
      ActionName.download,
      ActionName.downloadSequence,
      ActionName.clone,
      ActionName.hardware,
      ActionName.deduct,
      ActionName.render,
      ActionName.crossPlatformClone,
      ActionName.crossPlatformTransferAssets,
      ActionName.share,
    ],
  ],
  [
    TaskStatus.timeOutStop,
    [
      ActionName.start,
      ActionName.abandon,
      ActionName.delete,
      ActionName.submit,
      ActionName.download,
      ActionName.downloadSequence,
      ActionName.clone,
      ActionName.hardware,
      ActionName.deduct,
      ActionName.render,
      ActionName.crossPlatformClone,
      ActionName.crossPlatformTransferAssets,
      ActionName.share,
    ],
  ],
  [
    TaskStatus.abandon,
    [
      ActionName.submit,
      ActionName.download,
      ActionName.downloadSequence,
      ActionName.deduct,
      ActionName.crossPlatformTransferAssets,
      ActionName.share,
    ],
  ],
  [
    TaskStatus.finishedTest,
    [
      ActionName.abandon,
      ActionName.delete,
      ActionName.submit,
      ActionName.download,
      ActionName.downloadSequence,
      ActionName.render,
      ActionName.clone,
      ActionName.hardware,
      ActionName.deduct,
      ActionName.crossPlatformClone,
      ActionName.crossPlatformTransferAssets,
      ActionName.share,
    ],
  ],
  [
    TaskStatus.finished,
    [
      ActionName.delete,
      ActionName.submit,
      ActionName.download,
      ActionName.downloadSequence,
      ActionName.render,
      ActionName.clone,
      ActionName.hardware,
      ActionName.deduct,
      ActionName.crossPlatformClone,
      ActionName.crossPlatformTransferAssets,
      ActionName.share,
    ],
  ], // WARNING: now status 25（已完成） also can execute full-render & re-commit action
  [
    TaskStatus.finishedHasFailed,
    [
      ActionName.delete,
      ActionName.submit,
      ActionName.download,
      ActionName.downloadSequence,
      ActionName.clone,
      ActionName.hardware,
      ActionName.deduct,
      ActionName.crossPlatformClone,
      ActionName.crossPlatformTransferAssets,
      ActionName.share,
    ],
  ],
  [
    TaskStatus.finishedHasStopped,
    [
      ActionName.delete,
      ActionName.submit,
      ActionName.download,
      ActionName.downloadSequence,
      ActionName.clone,
      ActionName.hardware,
      ActionName.deduct,
      ActionName.crossPlatformClone,
      ActionName.crossPlatformTransferAssets,
      ActionName.share,
    ],
  ],
  [TaskStatus.updating, []], // NOTE: updating status can not operate anything
  [TaskStatus.renderingTaskSubmitting, []],
  [
    TaskStatus.renderTaskSumbitFail,
    [ActionName.delete, ActionName.submit, ActionName.share],
  ],
  [
    CustomStatus.waitingAndNotMunuTaskId,
    [
      ActionName.stop,
      ActionName.delete,
      ActionName.hardware,
      ActionName.crossPlatformTransferAssets,
      ActionName.share,
    ],
  ], // special handle, represent the waiting status when the munuTaskId is null (same as 25)
]);

export const PreTaskStatusActionMap = new Map<number, ActionName[]>([
  [TaskStatus.waiting, [ActionName.stop, ActionName.submit, ActionName.delete]],
  [
    TaskStatus.rendering,
    [ActionName.stop, ActionName.submit, ActionName.delete],
  ],
  [TaskStatus.stop, [ActionName.start, ActionName.submit, ActionName.delete]],
  [TaskStatus.arrearageStop, [ActionName.start, ActionName.delete]],
  [
    TaskStatus.timeOutStop,
    [ActionName.start, ActionName.submit, ActionName.delete],
  ],
  [TaskStatus.finished, [ActionName.submit, ActionName.delete]],
  [TaskStatus.finishedHasStopped, [ActionName.submit, ActionName.delete]],
  [TaskStatus.finishedHasFailed, [ActionName.submit, ActionName.delete]],
  [TaskStatus.finishedTest, [ActionName.submit, ActionName.delete]],
  [TaskStatus.abandon, [ActionName.delete]],
  [TaskStatus.failed, [ActionName.submit, ActionName.delete]],
  [TaskStatus.updating, [ActionName.delete]],
  [TaskStatus.renderTaskSumbitFail, [ActionName.submit, ActionName.delete]],
]);

export const PostTaskStatusActionMap = new Map<number, ActionName[]>([
  [TaskStatus.waiting, [ActionName.stop, ActionName.submit, ActionName.delete]],
  [
    TaskStatus.rendering,
    [ActionName.stop, ActionName.submit, ActionName.delete],
  ],
  [
    TaskStatus.stop,
    [
      ActionName.start,
      ActionName.submit,
      ActionName.delete,
      ActionName.download,
    ],
  ],
  [
    TaskStatus.arrearageStop,
    [ActionName.start, ActionName.delete, ActionName.download],
  ],
  [
    TaskStatus.timeOutStop,
    [
      ActionName.start,
      ActionName.submit,
      ActionName.delete,
      ActionName.download,
    ],
  ],
  [
    TaskStatus.finished,
    [ActionName.submit, ActionName.delete, ActionName.download],
  ],
  [
    TaskStatus.finishedHasStopped,
    [ActionName.submit, ActionName.delete, ActionName.download],
  ],
  [
    TaskStatus.finishedHasFailed,
    [ActionName.submit, ActionName.delete, ActionName.download],
  ],
  [TaskStatus.finishedTest, [ActionName.submit, ActionName.delete]],
  [TaskStatus.abandon, [ActionName.delete]],
  [TaskStatus.failed, [ActionName.submit, ActionName.delete]],
  [TaskStatus.updating, [ActionName.delete]],
  [TaskStatus.renderTaskSumbitFail, [ActionName.submit, ActionName.delete]],
]);

export const RenderTaskStatusFilterList = [
  TaskStatus.waiting,
  TaskStatus.rendering,
  TaskStatus.stop,
  TaskStatus.timeOutStop,
  TaskStatus.arrearageStop,
  TaskStatus.finished,
  TaskStatus.finishedHasFailed,
  TaskStatus.finishedHasStopped,
  TaskStatus.finishedTest,
  TaskStatus.failed,
  TaskStatus.renderingTaskSubmitting,
  TaskStatus.renderTaskSumbitFail,
];

export const RenderTaskStatusFilterListChildren = [
  TaskStatus.timeOutStop,
  TaskStatus.arrearageStop,
  TaskStatus.finishedHasFailed,
  TaskStatus.finishedHasStopped,
];

export const RenderStatusRadiusMap = new Map<TaskStatus, TaskStatus[]>([
  [TaskStatus.waiting, [TaskStatus.waiting]],
  [TaskStatus.rendering, [TaskStatus.rendering]],
  [TaskStatus.preRendering, [TaskStatus.preRendering]],
  [TaskStatus.stop, [TaskStatus.stop]],
  [TaskStatus.arrearageStop, [TaskStatus.arrearageStop]],
  [TaskStatus.timeOutStop, [TaskStatus.timeOutStop]],
  [TaskStatus.finished, [TaskStatus.finished]],
  [
    TaskStatus.finishedHasStopped,
    [TaskStatus.finished, TaskStatus.finishedHasStopped],
  ],
  [
    TaskStatus.finishedHasFailed,
    [TaskStatus.finished, TaskStatus.finishedHasFailed],
  ],
  [TaskStatus.abandon, [TaskStatus.abandon]],
  [TaskStatus.finishedTest, [TaskStatus.finishedTest]],
  [TaskStatus.failed, [TaskStatus.failed]],
  [TaskStatus.analyse, [TaskStatus.analyse]],
  [TaskStatus.updating, [TaskStatus.updating]],
  [TaskStatus.renderingTaskSubmitting, [TaskStatus.renderingTaskSubmitting]],
  [TaskStatus.renderTaskSumbitFail, [TaskStatus.renderTaskSumbitFail]],
]);

export const RenderStatusColorMap = new Map<TaskStatus, any>([
  [TaskStatus.waiting, newTheme!["blue-1"]],
  [TaskStatus.rendering, newTheme!["blue-1"]],
  [TaskStatus.preRendering, newTheme!["blue-1"]],
  [TaskStatus.stop, newTheme!["orange-1"]],
  [TaskStatus.arrearageStop, newTheme!["orange-1"]],
  [TaskStatus.timeOutStop, newTheme!["orange-1"]],
  [TaskStatus.finished, newTheme!["green-2"]],
  [TaskStatus.finishedHasStopped, newTheme!["orange-1"]],
  [TaskStatus.finishedHasFailed, newTheme!["red-1"]],
  [TaskStatus.abandon, newTheme!["gray-7"]],
  [TaskStatus.finishedTest, newTheme!["blue-1"]],
  [TaskStatus.failed, newTheme!["red-1"]],
  [TaskStatus.analyse, newTheme!["blue-1"]],
  [TaskStatus.updating, newTheme!["blue-1"]],
  [TaskStatus.renderingTaskSubmitting, newTheme!["blue-1"]],
  [TaskStatus.renderTaskSumbitFail, newTheme!["red-1"]],
]);

export enum AIFlagType {
  Accelerate = 1,
  Lossless = 2,
}

export enum TaskType {
  /** 解算 */
  "GopRender" = "GopRender",
  /** 分布式解算  */
  "DistributedRender" = "DistributedRender",
  /** maya解算 */
  "Solve" = "Solve",
  /** 光子 */
  "RenderPhoton" = "RenderPhoton",
  /** 合并光子 */
  "MergePhoton" = "MergePhoton",
}

export enum ParamType {
  Select = 1,
  Input = 2,
}

export enum DependencyPrePostType {
  pre = "pre",
  post = "post",
  render = "render",
}

export enum DependencyTaskType {
  task = 0,
  frame = 1,
}
